'use client';

import { EventCardFragment } from '@/__generated__/graphql';
import { EVENT_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { useFragment } from '@apollo/client';
import { EventCard } from '../Cards/EventCard';

export default function EventResult({ id }: { id: string }) {
  const { data } = useFragment({
    fragment: EVENT_CARD_FRAGMENT,
    fragmentName: 'eventCard',
    from: { id, __typename: 'event_Entry' },
  });

  if (!data) return null;

  return <EventCard data={data as EventCardFragment} />;
}
